import { render, staticRenderFns } from "./GroupDashboardHeader.vue?vue&type=template&id=c5da2fa2&scoped=true"
import script from "./GroupDashboardHeader.vue?vue&type=script&lang=js"
export * from "./GroupDashboardHeader.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/group_dashboard/group_dashboard_header.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./GroupDashboardHeader.vue?vue&type=style&index=1&id=c5da2fa2&prod&scoped=true&lang=css"
import style2 from "./GroupDashboardHeader.vue?vue&type=style&index=2&id=c5da2fa2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5da2fa2",
  null
  
)

export default component.exports